<template>
  <div class="flex flex-column min-h-screen">
    <TopNavBar :role="''" />

  <div class="flex flex-column w-full main-content-container ">
    <div v-if="layoutType === 'full'" class="flex flex-column full-layout-content">
      <div class="flex align-items-center clickable-logo mt-4" @click="goHome">
        <img :src="logoImage" alt="logo" class="logo-image object-contain" />
      </div>
      <div class="flex-1 flex justify-content-center align-items-center p-4 bg-white w-full">
        <slot />
      </div>
    </div>
    <div v-else class="flex-1 flex layout-split">
      <div class="left-column flex flex-1 align-items-center"
        v-animateonscroll="{ enterClass: 'animate-enter slide-in-left' }"
        :class="imageAlign === 'start' ? 'justify-start' : 'justify-center'">
        <img v-if="imageSrc" :src="imageSrc" :class="fullImage ? 'illustration-image-full' : 'illustration-image'"
          alt="Illustration" class="max-w-full max-h-full object-contain" />
      </div>
      <div class="right-column flex flex-1 flex-column justify-content-center align-items-center p-4">
        <div class="flex align-items-center clickable-logo" @click="goHome">
          <img :src="logoImage" alt="logo" class="logo-image object-contain" />
        </div>

        <div class="w-full max-w-md auth-content-slot ">
          <slot />
        </div>
      </div>
    </div>
  </div>
  </div>
</template>

<script setup>
import { defineProps } from "vue";
import TopNavBar from '@/layout/TopNavBar.vue';
const logoImage = require("@/assets/sideLogo.png");
import { useRouter } from 'vue-router';

const router = useRouter();


defineProps({
  layoutType: {
    type: String,
    default: '',
  },
  imageSrc: {
    type: String,
    required: false,
    default: "",
  },
  fullImage: {
    type: Boolean,
    default: false,
  },
  imageAlign: {
    type: String,
    default: "center",
  },
});
function goHome() {
  router.push('/');
}

</script>

<style scoped>
.min-h-screen {
  min-height: 100vh;
}
.main-content-container {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.full-layout-content {
  flex: 1;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.layout-split {
  flex: 1;
  width: 100%;
  display: flex;
  min-height: 100%;
}

.text-900 {
  color: var(--black-500) !important;
}

.left-column,
.right-column {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100%;
}

.illustration-image {
  width: 460px;
  height: auto;
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}

.illustration-image-full {
  width: 100%;
  height: calc(100vh - 8vh);
  object-fit: cover;
}

.clickable-logo {
  cursor: pointer;
}

.logo-image {
  width: 160px;
  height: auto;
}

.right-column {
  flex-direction: column;
  padding: 1rem;
  flex: 1;
  /* overflow-y: auto; */
}

.auth-content-slot {
  max-height: 100%;
  justify-content: center;
  flex-direction: column;
  justify-content: center;
}

@media (max-width: 768px) {

  .left-column {
    display: none !important;
  }

  .right-column {
    width: 100%;
    flex: 1;
    justify-content: center !important;
    align-items: center;
    background-color: #ffffff;
    overflow-y: auto;
  }

  .logo-image {
    width: 140px;
    margin-bottom: 10px;
  }
}
</style>